import { createTransform } from "redux-persist";
import CryptoJS from "crypto-js";

// Encryption key (you should store this securely, maybe as an environment variable)
const ENCRYPTION_KEY = "YOUR_ENCRYPTION_KEY";

// Create transform for encryption
const encryptTransform = createTransform(
  // Transform state on its way to being serialized and stored.
  (inboundState, key) => {
    // Encrypt inboundState
    const encryptedState = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      ENCRYPTION_KEY
    ).toString();
    return encryptedState;
  },
  // Transform state being rehydrated
  (outboundState, key) => {
    // Decrypt outboundState
    const decryptedState = CryptoJS.AES.decrypt(
      outboundState,
      ENCRYPTION_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedState);
  }
);

export default encryptTransform;
